// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Data
import CustomPageLayout from "examples/LayoutContainers/CustomPageLayout";
import { Grid } from "@mui/material";

import { useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { LoginFormContext } from "context/loginFormCtx";
import { getTenantAdminById, updateTenantAdmin } from "lib/Api/tenant-admin";
import AddEditTenantAdminForm from "components/Tenants/AddEditTenantAdminForm";

function EditTenantAdmin() {
  const { tenantId, adminId } = useParams();
  const navigate = useNavigate();
  const { setNotification } = useContext(LoginFormContext);
  const [adminData, setAdminData] = useState(null);

  const getAdminData = async () => {
    try {
      const response = await getTenantAdminById(adminId);
      if (response?.status === 200) {
        setAdminData(response?.data?.data);
      } else {
        setNotification({
          color: "error",
          icon: "cancel",
          title: "Error",
          content: response?.data?.message,
          open: true,
        });
        navigate(-1);
      }
    } catch (error) {
      setNotification({
        color: "error",
        icon: "cancel",
        title: "Error",
        content: error?.message || "Something went wrong!",
        open: true,
      });
    }
  };

  useEffect(() => {
    getAdminData();
    // eslint-disable-next-line
  }, [adminId]);

  return (
    <CustomPageLayout>
      <MDBox pt={3} pb={3}>
        <Card>
          <MDBox p={3} lineHeight={1}>
            <Grid container justifyContent="space-between" spacing={3}>
              <Grid item>
                <MDTypography variant="h5" fontWeight="medium">
                  Edit Tenant Admin
                </MDTypography>
                <MDTypography variant="button" color="text">
                  Here you can edit the Tenant Admin.
                </MDTypography>
              </Grid>
            </Grid>
          </MDBox>
          <MDBox p={3} lineHeight={1}>
            {adminData && (
              <AddEditTenantAdminForm
                initialData={adminData}
                isEdit={true}
              />
            )}
          </MDBox>
        </Card>
      </MDBox>
    </CustomPageLayout>
  );
}

export default EditTenantAdmin;
